import React from 'react';
import FeaturedAuthorTutoring from '../FeaturedAuthorTutoring';

import imageSrc from './my-guru.png';

const MyGuruEdgeTutoring = () => {
  return (
    <FeaturedAuthorTutoring
      imageSrc={imageSrc}
      description="MyGuru offers personalized SIE tutoring. Private SIE tutoring can make sense when you are looking to get organized around a study plan, struggling with specific concepts, or just really want to ensure you pass the next time you take the SIE with customized instruction and review of key concepts and missed practice problems. Initial sessions are diagnostic in nature, and while the tutor will review concepts and do some practice problems, time is also allocated to understanding the student’s strengths, weaknesses, timeline, and general questions and concerns. From there a study plan is developed. Pricing is $99 per hour, with 5, 10, or 15% discounts offered for students investing in 5, 10, or 15 hour packages. MyGuru’s primary SIE tutor is Richard V., who has deep experience as an online tutor and virtual classroom instructor. He has been teaching classes about investing since 1997, and since 2011 has been conducting virtual classes and 1-on-1 tutoring for the SIE, Series 7, Series 6, and Series 63."
      url="https://www.myguruedge.com/sie-tutor?utm_source=achievable"
      cta="Visit MyGuru's site"
    />
  );
};

export default MyGuruEdgeTutoring;
